import { counter } from '../counter';

// Call "old" counter js
counter();

/** The minimum time in seconds after which counters get updated. */
const MIN_UPDATE_TIME = 15;

const dateCounters = Array.from(
	document.querySelectorAll('.js-counter-date'),
).map(parseDateCounter);

for (const data of dateCounters) {
	updateCounter(data);

	// Update the counter whenever it's value increases, minimum from MIN_UPDATE_TIME
	const interval = Math.max(
		MIN_UPDATE_TIME,
		(data.dateEnd - data.dateStart) / (data.end - data.start),
	);
	data.timer = setInterval(() => updateCounter(data), interval * 1000);
}

/**
 * @param {DateCounterData} data
 * @param {number} [now]
 */
function updateCounter(data, now = Math.floor(Date.now() / 1000)) {
	const value = getCurrentValue(data, now);
	data.element.classList.toggle('counter__number--longnum', value > 99999);
	data.element.innerHTML = value.toLocaleString('de-DE');

	if (now >= data.dateEnd) {
		clearInterval(data.timer);
		data.timer = undefined;
	}
}

/**
 * @param {DateCounterData} data
 * @param {number} now
 * @returns {number}
 */
function getCurrentValue({ start, end, dateStart, dateEnd }, now) {
	if (now >= dateEnd) {
		return end;
	}
	return Math.round(
		(start + (now - dateStart) * (end - start)) / (dateEnd - dateStart),
	);
}

/**
 * @param {HTMLElement} element
 * @returns {DateCounterData}
 */
function parseDateCounter(element) {
	const { startValue, counterMax, startTime, startEnd } = element.dataset;
	const start = Number.parseInt(startValue);
	const end = Number.parseInt(counterMax);
	const dateStart = Number.parseInt(startTime);
	const dateEnd = Number.parseInt(startEnd);
	return { start, end, dateStart, dateEnd, element };
}

/**
 * @typedef {object} DateCounterData
 * @property {HTMLElement} element
 * @property {number} start
 * @property {number} end
 * @property {number} dateStart
 * @property {number} dateEnd
 * @property {number} [timer]
 */
